import React, { useEffect, useState } from 'react'
import { useSelector } from "src/stateManagement/redux";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Grid from "@mui/material/Grid2";
import moment from "moment";

export interface ITableProps {
    dataToTable: any[],
    setdataToTable: any,
    filteredData: any[],
    filters: any[]
}

interface catChangesMerged {
    id: string,
    changeDate: string,
    category?: string,
    comment?: string,
    userChangedBy: string,
    opeStatusInitial: string,
    opeStatusFinal: string,
}


const CatChanges = ({ dataToTable, setdataToTable, filteredData, filters }: ITableProps) => {

    const { categoriesChanges, fieldActivities } = useSelector((state) => state.location);

    const [dataColumns, setDataColumns] = useState<GridColDef[]>([
        {field: 'changeDate', headerName: 'Fecha', minWidth: 120, flex: 1},
        {field: 'category', headerName: 'Cat', minWidth: 70, flex: 1},
        // {field: 'comment', headerName: 'Comentario', minWidth: 100, flex: 1},
        {field: 'userChangedBy', headerName: 'Usuario', minWidth: 100, flex: 1},
        {field: 'opeStatusInitial', headerName: 'Estado Inicial', minWidth: 150, flex: 1},
        {field: 'opeStatusFinal', headerName: 'Estado Final', minWidth: 150, flex: 1},
    ])

    const paginationModel = { page: 0, pageSize: 10 };

    useEffect(() => {

        const catChangeByFieldActivities = fieldActivities.map((field: any) => {
            const opeStatusInitial = field.variables.find((variable: any) => variable.id === '26ab4565-c234-45d8-a24a-5328bcaee048')?.value;
            const opeStatusFinal = field.variables.find((variable: any) => variable.id === 'ad664c23-960c-4c32-a01a-6c4d52593ff9')?.value;

            return {
                id: field.fieldActivityId,
                changeDate: field.executedDate,
                opeStatusInitial,
                opeStatusFinal,
            }
        })

        let uniqueListOfDate = [...(catChangeByFieldActivities.map(c=>c.changeDate)), ...(categoriesChanges.map(c=>c.changeDate))]

        uniqueListOfDate = Array.from(new Set(uniqueListOfDate));

        const mergedActivities:any[] = []

        for (const element of uniqueListOfDate) {
            const filteredActivities = catChangeByFieldActivities.find((item:any) => item.changeDate === element);
            const filteredCategories = categoriesChanges.find((item:any) => item.changeDate === element);
            
            const merged = {
                id:filteredCategories? filteredCategories.id : filteredActivities?.id,
                changeDate: filteredCategories? filteredCategories.changeDate : filteredActivities?.changeDate,
                category: filteredCategories?.category,
                comment: filteredCategories?.comment,
                userChangedBy: filteredCategories?.userChangedBy,
                opeStatusInitial: filteredActivities?.opeStatusInitial,
                opeStatusFinal: filteredActivities?.opeStatusFinal,
            }

            mergedActivities.push(merged)            
        }

        const datToTable: any[] = []

        let sortActivities: any[] = [...mergedActivities].sort((a: any, b: any) => new Date(b.changeDate).getTime() - new Date(a.changeDate).getTime());

        for (const filter of filters) {
            const filterData = filteredData.find(f => f.name === filter.name);
            if (filterData) {
                if (filterData.action === 'greater') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] > filterData.value);
                } else if (filterData.action === 'less') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] < filterData.value);
                } else if (filterData.action === 'equal') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] === filterData.value);
                } else if (filterData.action === 'different') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] !== filterData.value);
                } else if (filterData.action === 'dissable') {
                    sortActivities = sortActivities || [];
                } else if (filterData.action === 'include' && filterData.value.length > 0) {
                    sortActivities = sortActivities.filter((x) => filterData.value.includes(x[filter.field]));
                } else if (filterData.action === 'equalAfter') {
                    sortActivities = sortActivities.filter((x) => {
                        const locationDate = moment(x.changeDate);
                        return locationDate.isSameOrAfter(filterData.value, 'day')
                    });
                } else if (filterData.action === 'equalBefore') {
                    sortActivities = sortActivities.filter((x) => {
                        const locationDate = moment(x.changeDate)
                        return locationDate.isSameOrBefore(filterData.value, 'day')
                    });
                }
            }
        }

        for (const act of sortActivities) {
            const data:any = {
                id: act.id,
                samplingDate: act.samplingDate,
                receptionDate: act.receptionDate,
                freeWaterPercentage: act.freeWaterPercentage,
            }


            const dateField:string[]= ['changeDate']

            for (const field of dateField) {
                if (act[field]) {
                    try {
                        data[field] = moment(act[field]).format('DD/MM/YYYY')
                    } catch (error) {
                        
                    }
                }
            }

            const doubleField:string[] = ['category']

            for (const field of doubleField) {
                if (act[field]) {
                    try {
                        data[field] = parseFloat(act[field])
                    } catch (error) {
                        
                    }
                }
            }

            const stringField:string[] = ['comment','userChangedBy','opeStatusInitial','opeStatusFinal']

            for (const field of stringField) {
                if (act[field]) {
                    try {
                        data[field] = act[field]
                    } catch (error) {
                    }
                }
            }

            datToTable.push(data)
        }

        setdataToTable(datToTable)

    }, [categoriesChanges,filteredData])


    return (
        <Grid className="table-container">
            <DataGrid
                rows={dataToTable}
                columns={dataColumns}
                initialState={{
                    pagination: { paginationModel }
                }}
                pageSizeOptions={[10, 20, 50, 100]}
                checkboxSelection={false}
                sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: "#316EBC",
                        color: "#fff",
                        fontWeight: "bold",
                    },
                }}
                getRowId={(row) => row.id}
            />
        </Grid>
    )
}

export default CatChanges